import React from 'react';
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <section id={id} className={`px-5 py-14 md:py-20 ${className}`} style={{
    paddingTop: "9px",
    paddingBottom: "23px"
  }} data-id="element-55" data-mp="3fwdimlmbyzv0">
      <div className="mx-auto w-full max-w-[620px]" data-id="element-56" data-mp="3kuylkssyvxn5">{children}</div>
    </section>;
}